'use client';

import React from 'react';
import { motion } from 'framer-motion';

interface AdminCardProps {
  children: React.ReactNode;
  title?: string;
  subtitle?: string;
  icon?: React.ElementType;
  className?: string;
  variant?: 'glass' | 'white' | 'solid';
  noPadding?: boolean;
}

export function AdminCard({ 
  children, 
  title, 
  subtitle, 
  icon: Icon, 
  className = '', 
  variant = 'glass',
  noPadding = false
}: AdminCardProps) {
  const baseStyles = "rounded-[28px] border transition-all duration-500 overflow-hidden";
  
  const variants = {
    glass: "bg-bg/90 backdrop-blur-md border-nature-muted/15 shadow-md hover:shadow-xl hover:shadow-black/8",
    white: "bg-bg border-nature-muted/12 shadow-md hover:shadow-xl",
    solid: "bg-plaster border-nature-muted/20 shadow-sm"
  };

  return (
    <div className={`${baseStyles} ${variants[variant]} ${className}`}>
      {(title || Icon) && (
        <div className={`relative px-8 pt-8 pb-4 ${Icon ? 'pr-[5.5rem]' : ''}`}>
          <div className="min-w-0 space-y-1">
            {title && (
              <h3 className="text-xl font-bold leading-snug tracking-tight text-soot">
                {title}
              </h3>
            )}
            {subtitle && (
              <p className="text-xs font-medium text-moss/90">
                {subtitle}
              </p>
            )}
          </div>
          {Icon && (
            <div className="absolute right-8 top-8 flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl border border-nature-muted/10 bg-bg text-soot shadow-sm">
              <Icon className="h-5 w-5" />
            </div>
          )}
        </div>
      )}
      <div className={`${noPadding ? '' : 'p-8 pt-4'}`}>
        {children}
      </div>
    </div>
  );
}
